export default "__VITE_ASSET__01570607__"